// Alert message
export class Message {
  type: String;
  text: String;

  constructor(props: { type?: String; text?: string }) {
    this.type = props.type || 'alert';
    this.text = props.text || '';
  }
}
